export default "__VITE_ASSET__609f670c__"